import "whatwg-fetch";
import React from "react";
import { createRoot } from "react-dom/client";
import configureFontAwesome from "../fontawesome/index";
import Homepage from "../components/Homepage";
import { AuthContextProvider } from "../auth/AuthContext";
import { RelayEnvironmentProvider } from "react-relay";
import environment from "../environment";

let homepageRoot;

const renderHomePage = (cookieDomain, validatedEmailToken) => {
  configureFontAwesome();
  const rootContainer = document.querySelector(".js-homepage-root");
  if (!rootContainer) return null;

  if (!homepageRoot) {
    homepageRoot = createRoot(rootContainer);
  }

  const dataContainer = document.querySelector("#auth_data");
  let data = {};
  if (dataContainer) {
    const jsonData = document.querySelector("#auth_data").textContent;
    data = JSON.parse(jsonData);
  }

  const errorContainer = document.querySelector(".messages");
  if (errorContainer) {
    errorContainer.remove();
  }

  homepageRoot.render(
    <RelayEnvironmentProvider environment={environment}>
      <AuthContextProvider
        validatedEmailToken={validatedEmailToken}
        cookieDomain={cookieDomain}
        googleAuthUrl={data.google_social_auth_url}
        linkedinAuthUrl={data.linkedin_social_auth_url}
      >
        <Homepage />
      </AuthContextProvider>
    </RelayEnvironmentProvider>
  );
};

window.jbRenderHomePage = renderHomePage;
